import { render, staticRenderFns } from "./table-top.vue?vue&type=template&id=17f8a940&scoped=true"
import script from "./table-top.vue?vue&type=script&lang=js"
export * from "./table-top.vue?vue&type=script&lang=js"
import style0 from "./table-top.vue?vue&type=style&index=0&id=17f8a940&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f8a940",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f8a940')) {
      api.createRecord('17f8a940', component.options)
    } else {
      api.reload('17f8a940', component.options)
    }
    module.hot.accept("./table-top.vue?vue&type=template&id=17f8a940&scoped=true", function () {
      api.rerender('17f8a940', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help/help-rules/table-top.vue"
export default component.exports